<template>
  <div>
    <Divider content-position="left">其他参数</Divider>
    <Field
      label="用户IP"
      :model-value="orderData.ipAddress"
      label-width="4.4em"
      readonly
    />
    <Divider />
  </div>
</template>

<script setup>
import { Field, Divider } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData } = useOrder();
</script>
